(() => {
  const SLIDER_SELECTOR = ".card-multicolumn.card-multicolumn--slider";

  const initSlider = (sliderEl) => {
    if (!sliderEl || sliderEl.swiper) return; // avoid double init
    if ((sliderEl.dataset.layout || "grid") !== "slider") return;

    // ✅ correct dataset keys
    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 3);
    const productsPerRowMobile = 1.2;

    // If Swiper isn’t present, don’t crash
    if (typeof window.Swiper === "undefined") {
      console.warn(
        "[card-multicolumn] Swiper not found. Include swiper-bundle.min.js & .css"
      );
      return;
    }

    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1100 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const nextBtn = sliderEl.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = sliderEl.querySelector(
      ".heading-group__navigation-button-prev"
    );

    const paginationElement = sliderEl.querySelector(
      ".heading-group__pagination"
    );

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      slidesPerGroup: 1,
      spaceBetween: 10,
      speed: 800,
      allowTouchMove: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationElement,
        type: "fraction",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
          slidesPerGroup: slidesPerView576,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: slidesPerView990,
          slidesPerGroup: slidesPerView990,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          spaceBetween: 20,
        },
        1100: {
          slidesPerView: slidesPerView1100,
          slidesPerGroup: slidesPerView1100,
          slidesOffsetBefore: 100,
          slidesOffsetAfter: 100,
          spaceBetween: 20,
        },
        1360: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
          slidesOffsetBefore: 100,
          slidesOffsetAfter: 100,
          spaceBetween: 20,
        },
         1660: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
          slidesOffsetBefore: 110,
          slidesOffsetAfter: 110,
          spaceBetween: 20,
        },
         1900: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
          slidesOffsetBefore: 180,
          slidesOffsetAfter: 180,
          spaceBetween: 20,
        },
        2000: {
          slidesPerView: slidesPerView1360,
          slidesPerGroup: slidesPerView1360,
          slidesOffsetBefore: 350,
          slidesOffsetAfter: 350,
          spaceBetween: 20,
        }
      },
    };

    new Swiper(sliderEl, sliderSettings);
  };

  const destroySlider = (sliderEl) => {
    if (!sliderEl) return;
    if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    sliderEl
      .querySelectorAll(".swiper-slide")
      .forEach((s) => s.removeAttribute("style"));
  };

  const mountAll = (root = document) => {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  };
  const unmountAll = (root = document) => {
    root.querySelectorAll(SLIDER_SELECTOR).forEach(destroySlider);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => mountAll());
  } else {
    mountAll();
  }

  document.addEventListener("shopify:section:load", (e) => mountAll(e.target));
  document.addEventListener("shopify:section:unload", (e) =>
    unmountAll(e.target)
  );
})();
